import type {FunctionComponent} from "react";
import {Typography} from "@mui/material";
import {ErrorOutline} from "@mui/icons-material";
import type {ToastContentProps} from "react-toastify";

export interface IApiResponseErrorToastContent {
    message: string,
}

const ApiResponseErrorToastContent: FunctionComponent<ToastContentProps<IApiResponseErrorToastContent>> =
    ({
         data,
     }) => {

        return (
            <>
                <div className={'toast-content'}>
                    <ErrorOutline color={'error'} sx={{marginRight: 1}}/>
                    <Typography variant={'body2'}>
                        {data?.message ?? ''}
                    </Typography>
                </div>
            </>
        )
    }

export default ApiResponseErrorToastContent;
